import type { FunctionComponent } from 'react';
import React from 'react';

import { ScopedTheme } from '@yandex-360/orb-components/dist/components/Theme';

import type { AccordionItemProps } from './AccordionItem';
import AccordionItem from './AccordionItem';

interface Props {
    items: AccordionItemProps[];
}

/**
 * Заменить на орбитовский аккордион когда они его запилят
 * @deprecated
 */
export const Accordion: FunctionComponent<Props> = ({ items }) => {
    return (
        <ScopedTheme theme="dark">
            <div>
                {items.map((item) => (
                    <AccordionItem key={item.title} {...item} />
                ))}
            </div>
        </ScopedTheme>
    );
};
